import React from 'react';
import { Text } from '@fullstory/components';

export const UserVariableItem: React.FC<{
  property: string;
  value: React.ReactNode;
}> = ({ property, value }) => (
  <>
    <Text appearance="bodyMedium" color="secondary">
      {property}
    </Text>
    <Text appearance="bodyMedium" color="default">
      {value}
    </Text>
  </>
);
